import React, { useContext, useEffect, useState } from "react";
import styles from '../register/Register.module.css';
import { useNavigate, useParams } from "react-router-dom";
import { LoggedInContext } from "../../providers/LoggedInContext";
import FooterExternal from "../../footer/FooterExternal";
import PrivacyPolicyViewer from "../../privacyPolicy/PrivacyPolicyViewer";
import { ReactComponent as HiQlogo } from '../../imgs/logos/HiQ.svg';

export default function HiQForgotPassword(){

    const navigate = useNavigate();

    const {backendEndpoint,setLoading} = useContext(LoggedInContext);

    const [validEmail,setValidEmail] = useState('');
    const [email,setEmail] = useState('');
    
    const handleChangeEmail = (e) => {
        setEmail(e.target.value)
    }

    const handleResetPassword = () => {
        setLoading(true);
        fetch(backendEndpoint+'/resetPassword',{
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({inviteCode: window.crypto.randomUUID(),email}),
            credentials: "include"
        })
        .then((res) => res.text())
        .then((data) => {
            const recObj = JSON.parse(data);
            if(recObj.status === 'valid'){
                setValidEmail(email);
            } else {
                setValidEmail('invalid');
            }
            setLoading(false);
        })
        .catch((err) => console.log(err));
    }

    const handleNavigateLogin = () => {
        navigate('/hiq/login');
    }

    const emailPane = () => {
        return(
            <div className={`${styles.paneLower}`}>
                <h2>Password Reset Request</h2>
                <div className={styles.emailPane}>
                    <p>Enter your email address below to request a password reset link via email. If you do not receive an email, contact us at it@stratela.co.uk for assistance.</p>
                    <br/>
                    <label>Enter your email address:</label>
                    <input type="text" onChange={handleChangeEmail} value={email}/>
                    <p className={styles.errorMessage}>{validEmail === 'invalid'? 'Invalid email address' : ''}</p>
                </div>
                <div className={styles.footer}>
                    <button className={styles.nextBtn} onClick={handleResetPassword}>Reset</button>
                </div>
            </div>
        )
    }
    const resultPane = () => {
        return (
            <div className={`${styles.paneLower} ${styles.invalid}`}>
                <p>Password reset request submitted successfully</p>
                <div className={styles.footer}>
                    <button className={styles.nextBtn} onClick={handleNavigateLogin}>Go to Login</button>
                </div>
            </div>
        )
    }
    const paneSwitcher = () => {
        if(validEmail === 'invalid' || validEmail === ''){
            return emailPane();
        } else {
            return resultPane();
        }
    }

    return (
        <>
            <main className={`${styles.background} ${styles.hiq}`}>
                <div className={styles.overlay}></div>
                <div className={styles.paneContainer}>
                    <div className={styles.pane}>
                        <div className={styles.paneUpper}>
                            <span><strong>Goodyear</strong> Retail Brand Hub</span><div className={styles.divider}></div><div className={styles.svgCon}><HiQlogo/></div>
                        </div>
                            {paneSwitcher()}
                    </div>
                </div>
            </main>
            <FooterExternal />
        </>
    )    
}